import { connect } from 'react-redux';
import ReturnCreditsDialog from './ReturnCreditsDialog';

const mapStateToProps = () => ({});
export default connect(mapStateToProps, null)(ReturnCreditsDialog);
